module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/3_7eaf239289aa2f74e88145d6a8f354ff.png";